import MyError from 'api/Error';
import * as ProviderItemFields from './providerTypes';
import * as DocumentExport from '../entity/Document';

export class Provider {
  constructor(
    id,
    categories,
    address,
    user,
    name,
    status,
    documents,
    publicProperties,
    tags,
    description,
    bookmark,
    rootDocument
  ) {
    this.id = id;
    this.categories = categories;
    this.address = address;
    this.user = user;
    this.name = name;
    this.status = status;
    this.documents = documents;
    this.publicProperties = publicProperties;
    this.tags = tags;
    this.description = description;
    this.bookmark = bookmark;
    this.rootDocument = rootDocument;
  }
}

export class ProviderItem {
  constructor(
    providerId,
    status = defaultStatus,
    dadId,
    id,
    editable = true,
    order
  ) {
    this.providerId = providerId;
    this.status = status;
    this.dadId = dadId;
    this.id = id;
    this.editable = editable;
    this.order = order;
    this.type = providerItemType.item;
  }
}

class ProviderDocument extends ProviderItem {
  constructor(providerId, status, dadId, id, document, editable, order) {
    super(providerId, status, dadId, id, editable, order);
    this.document = document;
    this.type = ProviderItemFields.providerItemType.document;
    this.name = document.properties.displayName;
  }
}
export default ProviderDocument;

export function validate(providerDocument, file) {
  if (
    !providerDocument.name &&
    providerDocument.document.properties.type ===
      DocumentExport.documentType.info
  ) {
    return Promise.reject(new MyError({ message: 'document.name.empty' }));
  } else {
    return Promise.resolve();
  }
}

export const providerItemType = {
  document: 'document',
  folder: 'folder',
  link: 'link',
  item: 'item',
  survey: 'survey',
  chart: 'chart',
  searchTag: 'searchTag',
  surveyReport: 'surveyReport',
  report: 'report',
  itemLink: 'itemLink',
  externalLink: 'externalLink',
};

const defaultStatus = 'toUpload';
